/** @format */

import React from "react";

const DatosPersonales = ({
  formData,
  handleChange,
  formDataEstados,
  formDataPaises,
}) => {
  return (
    <div
      id='datos_personales'
      className='personal-info'
    >
      <div>
        <label htmlFor='nombres'>Nombres(s) (Obligatorio)</label>
        <input
          type='text'
          id='nombres'
          name='nombres'
          value={formData.nombres}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='apellido_paterno'>
          Apellidos Paterno (Obligatorio)
        </label>
        <input
          type='text'
          id='apellido_paterno'
          name='apellido_paterno'
          value={formData.apellido_paterno}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='apellido_materno'>Apellidos Materno</label>
        <input
          type='text'
          id='apellido_materno'
          name='apellido_materno'
          value={formData.apellido_materno}
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor='fecha_nacimiento'>
          Fecha de nacimiento (Obligatorio)
        </label>
        <input
          type='date'
          id='fecha_nacimiento'
          name='fecha_nacimiento'
          value={formData.fecha_nacimiento}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='genero'>Género</label>
        <select
          id='genero'
          name='genero'
          value={formData.genero}
          onChange={handleChange}
          required
        >
          <option
            value=''
            disabled
          >
            -- Elija uno --
          </option>
          <option value='Femenino'>Femenino</option>
          <option value='Masculino'>Masculino</option>
        </select>
      </div>
      <div>
        <label htmlFor='estado'>Estado de nacimiento</label>
        <select
          id='estado_nacimiento'
          name='estado_nacimiento'
          value={formData.estado_nacimiento}
          onChange={handleChange}
          required
        >
          <option
            value=''
            disabled
          >
            -- Elija uno --
          </option>
          {formDataEstados.map((estado) => (
            <option
              key={estado.id_Estado}
              value={estado.nombre}
            >
              {estado.nombre}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor='nacionalidad'>Nacionalidad</label>
        <input
          type='text'
          id='nacionalidad'
          name='nacionalidad'
          value={formData.nacionalidad}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='pais'>Por favor, selecciona tu país</label>
        <select
          id='pais'
          name='pais'
          value={formData.pais}
          onChange={handleChange}
          required
        >
          <option
            value=''
            disabled
          >
            -- Elija uno --
          </option>
          <option
            value=''
            disabled
          >
            -- Elija uno --
          </option>
          {formDataPaises.map((pais) => (
            <option
              key={pais.id}
              value={pais.nombre}
            >
              {pais.nombre}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor='curp'>CURP (Obligatorio)</label>
        <input
          type='text'
          id='curp'
          name='curp'
          value={formData.curp}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='mail'>Correo electrónico</label>
        <input
          type='email'
          id='mail'
          name='mail'
          value={formData.mail}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='celular'>Teléfono celular (10 dígitos)</label>
        <input
          type='tel'
          id='celular'
          name='celular'
          value={formData.celular}
          onChange={handleChange}
          maxLength='10'
          required
        />
      </div>
      {/* <button
        type='submit'
        className='btn btn-primary'
      >
        Enviar
      </button> */}
    </div>
  );
};

export default DatosPersonales;
